module.exports = __webpack_public_path__ + "media/shopify_empty_scene.fc7d7d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopify_empty_scene.png
// module id = ./src/assets/shopify_empty_scene.png
// module chunks = 0